import { useCallback } from 'react'
import { useExport } from './useExport'
import {
  createStoreModelExport,
  getStoreModelExport,
} from '@/api/storeModelExports'

/**
 * Hook to export a store model's detail, full store list, and historicals.
 * Uses the generic useExport hook with store-model-specific endpoints.
 */
export function useStoreModelExport(modelId: string) {
  const createFn = useCallback(() => createStoreModelExport(modelId), [modelId])

  const exportHook = useExport<void>({
    createExportFn: createFn,
    getExportFn: getStoreModelExport,
    filenamePrefix: 'store-model',
  })

  return {
    ...exportHook,
    exportStoreModel: exportHook.startExport,
  }
}

// Re-export types for convenience
export type { ExportStatus, ExportState } from './useExport'
